import Clips from "../components/Clips";
import SocialLinks from "../components/SocialLinks";
const HeroBanner = ({data}) => {
     
    return (
        <>
            <div className="flex flex-col items-center mt-4 gap-4 ">
                <h2 className="text-center font-extrabold text-xl leading-6 md:text-2xl lg:text-3xl">{data.title} <br /> {data.subtitle}</h2>
                <button className="py-1 px-4 bg-slate-300 rounded-2xl text-[15px] md:text-xl">{data.btntext}</button>
            </div>
            <div className="flex my-4 justify-between">
                <ul className="flex gap-2 flex-col">
                    {
                       data.videos.map((video, index) => {
                            return <Clips video={video} key={index} />
                        })
                    }
                </ul>
                <div className="rotate-[-25deg] hover:rotate-0  cursor-pointer transition-all">
                    <img className="w-[200px] md:w-[320px]" src={data.img} alt="heroImage" />
                </div>
                <ul className="flex gap-2 flex-col">
                    {
                        data.sociallinks.map((social, index) => {
                            return <SocialLinks links={social} key={index} />
                        })
                    }
                </ul>
            </div>

        </>
    )
}
export default HeroBanner;